module.exports = __webpack_public_path__ + "img/ic_refresh.4f4b4dc8.svg";